import React from "react";
import { ArrowRight, ShieldCheck, Truck, Wrench, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BUSINESS } from "@/data/business";

const HERO_IMG =
  "https://images.unsplash.com/photo-1484154218962-a197022b5858?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwYXBwbGlhbmNlc3xlbnwwfHx8fDE3ODMxOTI5MjN8MA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-white" data-testid="hero-section">
      <div className="container-b grid grid-cols-1 items-center gap-12 py-16 md:grid-cols-2 md:py-24">
        <div className="fade-up">
          <div className="inline-flex items-center gap-2 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
            <MapPin className="h-3.5 w-3.5" /> Fatehpur, Gaya · Bihar
          </div>
          <h1 className="font-heading mt-5 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
            Every Home Appliance,
            <span className="block text-blue-700">One Trusted Store.</span>
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 md:text-lg">
            {BUSINESS.name} brings you the widest range of TVs, ACs, refrigerators, washing machines,
            kitchen appliances and furniture from all leading brands — with genuine warranty and doorstep service.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="rounded-full bg-blue-700 px-7 text-base font-semibold text-white hover:bg-blue-800"
              data-testid="hero-primary-cta"
            >
              <a href="#offer">
                See Lagan Combo Offer <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full border-slate-300 px-7 text-base font-semibold text-slate-900 hover:bg-slate-50"
              data-testid="hero-secondary-cta"
            >
              <a href="#contact">Get in Touch</a>
            </Button>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 border-t border-slate-200 pt-6">
            <Feature icon={<ShieldCheck className="h-5 w-5" />} label="Genuine warranty" />
            <Feature icon={<Truck className="h-5 w-5" />} label="Home delivery" />
            <Feature icon={<Wrench className="h-5 w-5" />} label="After-sales service" />
          </div>
        </div>

        <div className="fade-up delay-2 relative">
          <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-slate-100 shadow-2xl">
            <img
              src={HERO_IMG}
              alt="Modern home appliances"
              className="h-[420px] w-full object-cover md:h-[520px]"
              data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/40 via-transparent to-transparent" />
          </div>

          <div className="absolute -bottom-6 left-6 hidden max-w-xs rounded-2xl border border-slate-200 bg-white p-4 shadow-xl sm:block">
            <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-blue-700">GST Registered</div>
            <div className="mt-1 font-mono text-sm font-semibold text-slate-900">10BZDPB2001B2ZU</div>
            <div className="mt-1 text-xs text-slate-500">100% authentic products & bills</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Feature({ icon, label }) {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-700">
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 text-blue-700">
        {icon}
      </span>
      <span className="font-medium">{label}</span>
    </div>
  );
}
